import { AfterViewInit, Component, ContentChildren, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild } from '@angular/core';
import { fromEvent } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-action-sheet',
  templateUrl: './action-sheet.component.html',
  styleUrls: ['./action-sheet.component.scss']
})
export class ActionSheetComponent implements OnInit {

  @Input() actionSheetTitle : string; 
  @Output() clickedOut = new EventEmitter<boolean>();
  @Output() clickedCloseBtn = new EventEmitter<boolean>();
  isContentActive = false;

  constructor() { }

  ngOnInit(): void {
    // setTimeout(() => {
    //   this.isContentActive = true;
    // },300);
  }
  public clickedOutActionSheet() {
    this.clickedOut.emit(true);
  }

  public clickedCloseBtnActionSheet() {
    this.clickedCloseBtn.emit(true);
  }

}
